/**
 * 组织树 → 平台店铺列表（门店切换数据源）
 */

import { organizationService } from '@/services/organizationApi';
import { unwrapApiResult } from '@/utils/artMapper';
import {
  flattenOrgDepartmentTree,
  extractOrgLeafStores,
  buildOrganizationHierarchy,
  isPlatformAdminRole,
  resolveAccessibleStoreIds,
} from '@/utils/orgMapper';

function resolveTenantId(options = {}) {
  if (options.tenantId != null && options.tenantId !== '') {
    return Number(options.tenantId) || options.tenantId;
  }
  const envTenant = import.meta.env.VITE_TENANT_ID;
  if (envTenant != null && envTenant !== '') {
    return Number(envTenant) || envTenant;
  }
  return 1;
}

export async function fetchOrganizationStoreTree(options = {}, platform = null) {
  try {
    const payload = await organizationService.getTree({
      tenantId: resolveTenantId(options),
    });
    const root = unwrapApiResult(payload);
    if (!root) return [];
    if (platform) {
      platform.organizationTree = buildOrganizationHierarchy(root);
      platform.rawOrgTree = root;
    }
    const leafStores = extractOrgLeafStores(root);
    if (leafStores.length > 0) return leafStores;
    return flattenOrgDepartmentTree(root);
  } catch (err) {
    if (import.meta.env.DEV) {
      console.info('[org-api] 远程组织树暂未配置或返回空，使用预置店铺列表', err);
    }
    return [];
  }
}

/**
 * 同步远程组织树到 platform.stores，并更新当前用户的 stores 授权列表
 */
export async function syncOrganizationStores(platform, user, roleKey, options = {}) {
  try {
    const departments = await fetchOrganizationStoreTree(options, platform);
    if (!departments.length) {
      return {
        stores: platform.stores || [],
        accessibleStoreIds: user?.stores || ['s1'],
        organizationTree: platform.organizationTree || null,
      };
    }

    platform.stores = departments.map(({ users, ...store }) => ({ ...store }));

    const accessibleStoreIds = resolveAccessibleStoreIds(user, departments, {
      allowAll: isPlatformAdminRole(roleKey),
    });

    if (accessibleStoreIds.length) {
      user.stores = accessibleStoreIds;
    }

    return {
      stores: platform.stores,
      accessibleStoreIds,
    };
  } catch {
    return {
      stores: platform.stores || [],
      accessibleStoreIds: user?.stores || ['s1'],
    };
  }
}
